<template>
  <div v-if="visible" class="address-selection-container">
    <Alert type="warning" :show-icon="true" icon-position="start" class="mb-4">
      <div class="h-full vertical-align-center"><p>Use recommended address instead?</p></div>
    </Alert>

    <div class="address-options-grid">
      <!-- Address You Entered -->
      <div
        class="address-option-card"
        :class="{ selected: selectedAddress === 'original' }"
        @click="handleSelectAddress('original')"
      >
        <div class="flex items-start gap-2 mb-2">
          <input
            type="radio"
            :checked="selectedAddress === 'original'"
            class="radio-input"
            @click.stop="handleSelectAddress('original')"
          />
          <div class="flex flex-col gap-2">
            <span class="address-title">Address you entered</span>
            <p class="address-text">{{ originalAddress }}</p>
          </div>
        </div>
      </div>

      <!-- Recommended Address -->
      <div
        class="address-option-card"
        :class="{ selected: selectedAddress === 'suggested' }"
        @click="handleSelectAddress('suggested')"
      >
        <div class="flex items-start gap-2 mb-2">
          <input
            type="radio"
            :checked="selectedAddress === 'suggested'"
            class="radio-input"
            @click.stop="handleSelectAddress('suggested')"
          />
          <div class="flex flex-col gap-2">
            <span class="address-title">Recommended</span>
            <p class="address-text">{{ suggestedAddress }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/NewLibrary/Alert.vue';

export default {
  name: 'AddressSelectionCard',
  components: {
    Alert,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    originalAddress: {
      type: String,
      required: true,
    },
    suggestedAddress: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'select'],
  data() {
    return {
      selectedAddress: this.modelValue || '',
    };
  },
  watch: {
    modelValue(newVal) {
      this.selectedAddress = newVal;
    },
  },
  methods: {
    handleSelectAddress(type) {
      this.selectedAddress = type;
      this.$emit('update:modelValue', type);
      this.$emit('select', type);
    },
  },
};
</script>

<style scoped>
/* Address Selection UI */
.address-selection-container {
  margin-top: 24px;
}

.mb-4 {
  margin-bottom: 16px;
}

.address-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;
}

.address-option-card {
  padding: 8px 12px 12px 12px;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  cursor: pointer;
  background-color: transparent;
  transition: border-color 0.2s;
  min-height: 100px;
}

.address-option-card:hover {
  border-color: #004879;
}

.address-option-card.selected {
  padding: 8px 12px 12px 12px;
  background-color: transparent;
}

.radio-input {
  width: 20px;
  height: 20px;
  border: 1px solid #004879;
  border-radius: 50%;
  appearance: none;
  position: relative;
  cursor: pointer;
  transition: border-color 0.2s;
  margin-top: 2px;
  flex-shrink: 0;
}

.radio-input:checked {
  border-color: #004879;
}

.radio-input:checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #004879;
}

.flex {
  display: flex;
}

.items-start {
  align-items: flex-start;
}

.gap-2 {
  gap: 8px;
}

.mb-2 {
  margin-bottom: 8px;
}

.address-title {
  color: #333;
  font-family: "IBM Plex Sans Hebrew";
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
}

.address-text {
  color: #666;
  font-family: "IBM Plex Sans Hebrew";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  word-break: break-word;
}
.vertical-align-center {
  vertical-align: middle;
  height: 24px;
  display: flex;
  align-items: center;
}
</style>
